import { cn } from '@/lib/utils'

interface SiteFooterProps {
  className?: string
}

export function SiteFooter({ className }: SiteFooterProps) {
  return (
    <footer className={cn('bg-background', className)}>
      <div className="mx-auto flex w-full max-w-page flex-col items-center justify-center gap-5 px-5 py-8 sm:px-8 md:flex-row">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted/70">
          © 2026 SEKAIZATO. ALL RIGHTS RESERVED.
        </p>
        {/* <div className="flex flex-wrap justify-center gap-6 sm:gap-8">
          {footerLinks.map((link) => (
            <a key={link} href="#contact" className="font-mono text-[12px] text-muted/80 transition hover:text-primary">
              {link}
            </a>
          ))}
        </div> */}
      </div>
    </footer>
  )
}
